// extracted by mini-css-extract-plugin
module.exports = {"basketLink":"BasketLink_basketLink__3dFLU","enabled":"BasketLink_enabled__1rvV7","notEmpty":"BasketLink_notEmpty__3CZe3"};